/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MaintenanceEventApi } from './maintenanceEventApi';
import type { MaintenanceStateCurrentMaintenance } from './maintenanceStateCurrentMaintenance';

/**
 * Maintenance state that can be displayed to users
 */
export interface MaintenanceState {
  maintenanceEvents?: MaintenanceEventApi[];
  /** Check if tenant is currently in maintenance mode */
  readonly isInMaintenance: boolean;
  /** Get current maintenance event if any */
  readonly currentMaintenance: MaintenanceStateCurrentMaintenance;
}
